import { type JSONState } from '#types/form/wizard.ts'

interface CheckIfValuesHaveChanged<T> {
	formState: JSONState<T>['formState']
	oldFormState: JSONState<T>['oldFormState']
	id: string
}

export function checkIfValuesHaveChanged<T>({
	formState,
	oldFormState,
	id,
}: CheckIfValuesHaveChanged<T>) {
	if (!formState) {
		throw new Error('formState is not defined')
	}

	if (!oldFormState) {
		throw new Error('oldFormState is not defined')
	}

	if (!id) {
		throw new Error('id is not defined')
	}

	const currentValue = formState[id as keyof typeof formState]
	const oldValue = oldFormState[id as keyof typeof oldFormState]

	return currentValue === oldValue
}
